import { isAxiosError, type AxiosInstance } from "axios";
import type { Usuario } from "./usuario";

type SearchRequest = {
    id?: string
    login?: string
    nome?: string
    tipo?: string
    limit?: number
    offset?: number
}

export class UsuarioRepository {
    constructor(
        private api: AxiosInstance
    ) { }

    async searchOne(request: SearchRequest): Promise<Usuario> {
        try {
            const { data } = await this.api.get<Usuario>(`/usuarios/search-one`, {
                params: request
            })

            return data
        } catch (error) {
            let message = 'Não foi possível buscar o registro'
            if (isAxiosError(error)) {
                message = error.response?.data.error
            }

            throw new Error(message)
        }
    }

    async search(request: SearchRequest): Promise<Usuario[]> {
        try {
            const { data } = await this.api.get<Usuario[]>(`/usuarios/search`, {
                params: request
            })

            return data
        } catch (error) {
            let message = 'Não foi possível buscar o registro'
            if (isAxiosError(error)) {
                message = error.response?.data.error
            }

            throw new Error(message)
        }
    }

    async count(request?: SearchRequest): Promise<number> {
        try {
            const { data } = await this.api.get<{ total: number}>(`/usuarios/count`, {
                params: request
            })

            return data.total
        } catch (error) {
            let message = 'Não foi possível buscar o registro'
            if (isAxiosError(error)) {
                message = error.response?.data.error
            }

            throw new Error(message)
        }
    }

    async save(request: Omit<Usuario, 'id'> & { id?: string, senha?: string}): Promise<Usuario> {
        try {
            const { data } = await this.api.post<Usuario>(`/usuarios/save`, request)

            return data
        } catch (error) {
            let message = 'Não foi possível buscar o registro'
            if (isAxiosError(error)) {
                message = error.response?.data.error
            }

            throw new Error(message)
        }
    }

    async remove(ids: string[]): Promise<void> {
        await this.api.delete(`/usuarios/delete`, {
            data: {
                ids
            }
        })
    }
}